'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@src/components/Skeleton/Skeleton';
export function SocialLadderSkeleton() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-center gap-3 lg:hidden">{Array.from({
        length: 3
      }).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mt-3 flex items-center justify-center gap-3 lg:hidden">{Array.from({
        length: 4
      }).map(_temp2)}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="hidden items-center justify-between gap-8 lg:flex">{Array.from({
        length: 7
      }).map(_temp3)}</div>;
    t3 = <div className="my-5 h-px bg-bodi-gray-light lg:my-4" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Skeleton.Wrapper className="mx-auto flex max-w-full flex-col px-10 py-8 pt-6 lg:max-w-2xl lg:px-0 lg:pt-4">{t0}{t1}{t2}{t3}<div className="flex flex-col"><Skeleton.Block className="h-56 w-full" /><div className="my-5 h-px bg-bodi-gray-light lg:my-4" /><Skeleton.Block className="h-56 w-full" /></div></Skeleton.Wrapper>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp3(__1, index_1) {
  return <Skeleton.Block key={index_1} className="aspect-square size-16" />;
}
function _temp2(__0, index_0) {
  return <Skeleton.Block key={index_0} className="aspect-square size-16" />;
}
function _temp(_, index) {
  return <Skeleton.Block key={index} className="aspect-square size-16" />;
}